import React from 'react';
import { Tag } from './Tag';
import { Chip, Box } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

export const TagContainer = ({
  tags = [],
  maxVisible = 5,
  onAddTag,
  onTagClick,
  onRemoveTag,
  variant = 'inline',
  isMobile = false,
  addButtonClassName,
  showAddText = true,
  mobileTouchFriendly = false,
}) => {
  const visibleTags = tags.slice(0, maxVisible);
  const remainingCount = tags.length - maxVisible;

  return (
    <Box 
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: mobileTouchFriendly ? '8px' : '4px',
        alignItems: 'center'
      }}
    >
      {visibleTags.map((tag) => (
        <Tag
          key={tag.tag_id}
          tag={tag}
          onClick={() => onTagClick(tag)}
          onRemove={() => onRemoveTag(tag)}
          compact={!mobileTouchFriendly}
          touchFriendly={mobileTouchFriendly}
        />
      ))}
      
      {remainingCount > 0 && (
        <Chip
          label={`+${remainingCount}`}
          size="small"
          variant="outlined"
          sx={{
            height: mobileTouchFriendly ? '28px' : '18px',
            fontSize: mobileTouchFriendly ? '12px' : '10px',
            padding: 0,
            borderRadius: '12px',
            backgroundColor: 'rgba(32, 36, 45, 0.3)',
            color: '#939393',
            borderColor: 'rgba(100, 100, 100, 0.3)',
            '.MuiChip-label': {
              padding: mobileTouchFriendly ? '0 10px' : '0 6px',
              fontWeight: 500,
              lineHeight: 1.2,
            },
          }}
        />
      )}
      
      {onAddTag && (
        <Chip
          icon={<AddIcon style={{ 
            fontSize: mobileTouchFriendly ? 20 : 14, 
            margin: mobileTouchFriendly ? 4 : 3 
          }} />}
          label={showAddText ? "Add tag" : ""}
          onClick={onAddTag}
          size={mobileTouchFriendly ? "medium" : "small"}
          variant="outlined"
          className={addButtonClassName}
          sx={addButtonClassName ? {} : {
            height: mobileTouchFriendly ? '32px' : '18px',
            fontSize: mobileTouchFriendly ? '13px' : '10px',
            padding: mobileTouchFriendly ? '0 4px' : 0,
            borderRadius: '16px',
            backgroundColor: 'rgba(32, 36, 45, 0.3)',
            color: '#a0a0a0',
            borderColor: 'rgba(100, 100, 100, 0.3)',
            opacity: isMobile ? 1 : 0,
            transition: 'all 0.2s ease-out',
            '.MuiChip-label': {
              padding: showAddText ? (mobileTouchFriendly ? '0 10px 0 2px' : '0 8px 0 0') : '0',
              fontWeight: 500,
              lineHeight: 1.2,
            },
            '&:hover': {
              backgroundColor: 'rgba(70, 70, 70, 0.3)',
              color: '#d0d0d0',
              borderColor: 'rgba(150, 150, 150, 0.5)',
            },
            '.group:hover &': {
              opacity: 1,
            }
          }}
        />
      )}
    </Box>
  );
}; 